var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{staticClass:"elevation-2",attrs:{"headers":_vm.colunas,"items":_vm.impostos,"hide-default-header":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatarPorcentagem")(item.valor))+" ")]}},{key:"item.valorCalculadoImposto",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatarDinheiro")(_vm.obterTotalImposto(item)))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }